/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { BoxPickerContext } from './BoxPicker.context';
import { BoxPickerItem } from './BoxPickerItem';

export type BoxPickerProps<T> = {
  multiple?: boolean;
  children: any;
  selected: T[];
  onChange: (value: T[]) => void;
};

const { Provider } = BoxPickerContext;

export function BoxPicker<T = any>(props: BoxPickerProps<T>) {
  const { onChange, multiple = false, children, selected } = props;
  const isActive = (value: any) => {
    return selected.indexOf(value) > -1;
  };

  const onItemChange = (value: any) => {
    if (!multiple) {
      return onChange([value]);
    }
    let nextSelected = [...selected];
    if (isActive(value)) {
      nextSelected = nextSelected.filter(item => item !== value);
    } else {
      nextSelected.push(value);
    }
    onChange(nextSelected);
  };

  return (
    <Provider
      value={{
        onItemChange,
        isActive,
      }}
    >
      {children}
    </Provider>
  );
}

BoxPicker.Item = BoxPickerItem;
